import React from "react";
import { Alert, Button, Container } from "react-bootstrap";

class IncentivesErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("IncentivesErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="py-5">
          <Alert variant="danger">
            <Alert.Heading>Something went wrong</Alert.Heading>
            <p>The incentives dashboard failed to load. You can try refreshing the page.</p>
            <hr />
            <div className="d-flex gap-2">
              <Button
                variant="outline-danger"
                onClick={() => this.setState({ hasError: false, error: null })}
              >
                Try again
              </Button>
              <Button variant="outline-secondary" onClick={() => window.location.reload()}>
                Refresh page
              </Button>
            </div>
          </Alert>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default IncentivesErrorBoundary;
